import { RouteConfig } from 'vue-router';
import { ContactDirectory, CreateContactView } from '@/components/users';
import UpdateContactView from '@/modules/contacts/management/views/UpdateContactView.vue';
import { Actions, Resources } from '@/modules/shared/shared/domain/constants/constants';

export const contactsRouter: RouteConfig[] = [
    {
        path: 'contacts',
        name: 'contacts',
        component: ContactDirectory,
        props: true,
    },
    {
        path: 'create-contact',
        name: 'create-contact',
        component: CreateContactView,
        meta: {
            privilege: {
                action: Actions.CREATE.name,
                resource: Resources.PRIVILEGE_ADMINISTRATION.name,
            },
        },
    },
    {
        path: 'update-contact',
        name: 'update-contact',
        component: UpdateContactView,
        meta: {
            privilege: {
                action: Actions.CREATE.name,
                resource: Resources.PRIVILEGE_ADMINISTRATION.name,
            },
        },
    },
];
